export type ItemCustomField = {
  id: number;
  created_at: string;
  updated_at: string;
  source_id: number;
  user_id: number;
  changed_by_user_id: number | null;
  item_id: number;
  brand_custom_field_id: number;
  value: string;
};

export type MappedItemCustomFields = {
  id: number | string;
  custom_field_type_id: number;
  name: string;
  options: CustomFieldOption[];
  headers?: CustomFieldOption[];
  table_delimiter?: string;
  table_row_delimiter?: string;
  product_relation_delimiter?: string;
  product_relation_brand_code_delimiter?: string;
  script_id: number | null;
  value: string;
  read_only_custom_field: number;
  dynamic_configuration: string | null;
  ai_configuration?: string | null;
  created_at: string;
  updated_at: string;
};

export type CustomFieldGroup = {
  id: number | string;
  brand_id?: number;
  record_number?: number;
  name: string;
  fields: BrandCustomField[];
  collapsed?: boolean;
};

export type ItemCustomFieldGroup = {
  id: number | string;
  name: string;
  fields: MappedItemCustomFields[];
  collapsed?: boolean;
};

export type BrandCustomField = {
  id: number;
  custom_field_type_id: CustomFieldType;
  record_number: number;
  visible_to_receiver: number;
  ignore_on_sync: number;
  script_id: number | null;
  name: string;
  group_id: number | null;
  options: CustomFieldOption[];
  headers?: CustomFieldOption[];
  table_delimiter?: string;
  table_row_delimiter?: string;
  product_relation_delimiter?: string;
  product_relation_brand_code_delimiter?: string;
  read_only_custom_field: number;
  dynamic_configuration: string | null;
  ai_configuration: string | null;
  description?: string | null;
  enhanced_validation_ids?: string | null;
};

export type CustomFieldOption = {
  id: number;
  custom_field_id: number;
  record_number: number;
  name: string;
};

export enum CustomFieldType {
  'Number' = 1,
  'Input' = 2,
  'Dropdown' = 3,
  'Checkbox' = 4,
  'Text_Editor' = 5,
  'Link' = 6,
  'Button' = 7,
  'Table' = 8,
  'Product_Relation' = 9,
  'Date' = 10,
}

export type CustomFieldIdName = {
  id: string;
  name: string;
};

export type ManualOverwritesMap = {
  [customFieldId: number]: number[];
};

export type ManualOverwritesState = {
  manualOverwrites: ManualOverwritesMap;
  loading: boolean;
  error: string | null;
};

export type EnhancedValidation = {
  id: number;
  name: string;
  description: string;
};
